var exports = {
  "a7": "releaseLink__UKO6BZ",
  "tY": "tagIconSuccess__DzlD48",
  "Z6": "tagIconMuted__cevcQT",
  "ej": "releaseInfo__KL5gjD",
  "tP": "releaseNameRow__cdVzvv",
  "do": "releaseName__F-UtsC",
  "mS": "latestLabel__3A88x2",
  "xR": "releaseMeta__Hsw3L4",
  "uI": "moreLink__4rhamn",
  "_s": "tagsLink__a4dr3v",
  "Yo": "tagCount__BG98Gx",
  "v6": "tagLabel___xw2O1",
  "p$": "emptyState__8cgPdc",
};

module.exports = exports;
